import { useEffect, useRef } from 'react';
import { transformationPillars } from '../../../mocks/landingData';

export default function TransformationPromiseSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-slide-up');
          }
        });
      },
      { threshold: 0.1 }
    );

    const section = sectionRef.current;
    if (section) {
      const elements = section.querySelectorAll('.animate-on-scroll');
      elements.forEach((el) => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-20 md:py-28 bg-warm-white">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="animate-on-scroll opacity-0 inline-flex items-center gap-2 px-4 py-2 rounded-full border border-dark-bronze/30 bg-dark-bronze/10 mb-6">
              <i className="ri-award-line text-dark-bronze text-sm" />
              <span className="text-dark-bronze text-sm font-medium">Our Promise</span>
            </div>

            <h2 className="animate-on-scroll opacity-0 font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-midnight mb-6">
              Top Notch Transformation starts with{' '}
              <span className="gold-gradient-text">one better question.</span>
            </h2>

            <p className="animate-on-scroll opacity-0 text-taupe-grey text-base md:text-lg leading-relaxed max-w-3xl mx-auto">
              TNT Coach AI is not just about motivation. It is about helping you think differently, act differently,
              and build a stronger version of yourself one decision, one question, and one action at a time.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {transformationPillars.map((pillar, index) => (
              <div
                key={index}
                className="animate-on-scroll opacity-0 group text-center p-8 rounded-2xl bg-midnight border border-royal-navy/30 hover:border-champagne-gold/40 transition-all duration-300 card-hover"
              >
                <div className="w-16 h-16 rounded-2xl gold-gradient flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-champagne-gold/20">
                  <i className={`${pillar.icon} text-midnight text-2xl`} />
                </div>
                <h3 className="font-heading text-xl font-semibold text-warm-white mb-3">{pillar.title}</h3>
                <p className="text-silver-grey text-sm leading-relaxed">{pillar.description}</p>
              </div>
            ))}
          </div>

          <div className="animate-on-scroll opacity-0 mt-12 flex justify-center">
            <a
              href="https://tnt-coach-ai.base44.app"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-10 py-4 rounded-full gold-gradient text-midnight font-bold text-lg hover:opacity-90 transition-all duration-300 shadow-xl shadow-champagne-gold/20 whitespace-nowrap"
            >
              <i className="ri-rocket-line" />
              Start Your Transformation
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}